import { exists, SystemCode, SystemCodeFromJSON } from '@/api'

export interface SystemCodeWithKey {
  id: number
  key: string
  length: number
  name: string
  nameKana: string
  note1: string
  note2: string
  note3: string
  revision: number
  codes: SystemCode[]
}

export function SystemCodeWithKeyFromJSON(json: any): SystemCodeWithKey {
  return {
    id: exists(json, 'id') ? json.id : 0,
    key: exists(json, 'key') ? json.key : '',
    length: exists(json, 'length') ? json.length : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    note1: exists(json, 'note1') ? json.note1 : '',
    note2: exists(json, 'note2') ? json.note2 : '',
    note3: exists(json, 'note3') ? json.note3 : '',
    revision: exists(json, 'revision') ? json.revision : 0,
    codes: json.codes.map(SystemCodeFromJSON)
  }
}

export const defaultSystemCodeWithKey = (): SystemCodeWithKey => ({
  id: 0,
  key: '',
  length: 0,
  name: '',
  nameKana: '',
  note1: '',
  note2: '',
  note3: '',
  revision: 0,
  codes: []
})
